import axios from "axios";
export const baseURL = "https://api.carjunction.ca"
const axiosInstance = axios.create({
    baseURL:baseURL,
    headers:{
        "Content-Type":"application/json"
    }
})
export default axiosInstance